import React from "react";
import { Link } from "react-router-dom";
import onServiceSS from "../../../assets/product-onservice.png";

const CallToAction = () => {
  const scrollHeader = () => {
    window.scrollTo({ top: 0, behavior: "instant" });
  };
  return (
    <div className="on-service-call-to-action-wrapper">
      <div className="" id="callToAction">
        <div
          className="call-to-action-container text-center"
          style={{ backgroundImage: "url('../../assets/bg-pattern.svg')" }}
        >
          <div
            className="position-relative right-side-width"
            style={{ gap: "15px" }}
          >
            <h4 className="title_text">
              See On Service
              <br /> in Action
            </h4>
            <p className="detail-info">
              Experience the full potential of our integrated service solutions.
              Join a live
              <br /> demonstration to see how we deliver efficient, scalable,
              and secure
              <br /> services tailored to your business needs.
            </p>
            <Link
              to="/connect-with-us"
              className="btn-md btn-dark border-0"
              onClick={scrollHeader}
            >
              Contact Us
            </Link>
          </div>
          <div className="image-container">
            <img src={onServiceSS} alt="image" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default CallToAction;
